import { createReducer } from "@reduxjs/toolkit";
import type { BatchParticipationInvoiceSubmissionState } from "@redux/state/educational-advisor-state";
import { resetSubmitBatchParticipationInvoice, submitBatchParticipationInvoice } from "./submit-batch-participation-invoice";

const initialState: BatchParticipationInvoiceSubmissionState = { processing: "idle", participationId: null };

export const submitBatchParticipationInvoiceReducer = createReducer<BatchParticipationInvoiceSubmissionState>(initialState, builder => {
  builder.addCase(submitBatchParticipationInvoice.fulfilled, (state, action) => {
    return { ...state, processing: "success", participationId: action.meta.arg.participationId };
  });
  builder.addCase(submitBatchParticipationInvoice.pending, (state, action) => {
    return { ...state, processing: "pending", participationId: action.meta.arg.participationId };
  });
  builder.addCase(submitBatchParticipationInvoice.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetSubmitBatchParticipationInvoice, () => {
    return initialState;
  });
});
